module.exports = __webpack_public_path__ + "static/media/white-bell-icon.c4b87700.svg";